import { TextAreaInput } from '@octano/global-ui';
import dayjs from 'dayjs';
import { Card, Col } from 'reactstrap';

import { FileDownload } from './FileDownload';
import { InputToolTip } from './InputToolTip';
import { MultipleFileDownload } from './MultipleFileDownload';
import { useTexts } from '../../../hooks/useTexts';
import SectionTitle from '../../../../../../../../components/Text/SectionTitle';
import { ViewStudentsPetition } from '../../../types';

interface StudentPetitionInfoProps {
  downloadFiles?: ViewStudentsPetition['docs'];
  downloadFileResponse?: ViewStudentsPetition['docResponse'];
  onlyView?: boolean;
  lastUpdate: any;
  lastUpdatedAt: any;
  currentStatus: any;
  downloadFileVoucher?: ViewStudentsPetition['voucher'];
  paidAt?: string;
}

export function StudentPetitionInfo({
  downloadFiles,
  downloadFileResponse,
  lastUpdate,
  lastUpdatedAt,
  currentStatus,
  downloadFileVoucher,
  paidAt,
}: StudentPetitionInfoProps) {
  const texts = useTexts().detail;
  return (
    <>
      <Card className="petition-info-resolution mb-4">
        <Col xs={12} sm={12} md={8} className="px-0">
          <Card
            className="d-flex flex-row justify-space-between"
            style={{ gap: 24 }}
          >
            <Col xs={12} md={6} className="px-0">
              <MultipleFileDownload
                label={texts.downloads.fileLabel}
                files={downloadFiles}
              />
            </Col>
            <Col xs={12} md={6} className="px-0">
              {downloadFileVoucher && (
                <>
                  <FileDownload
                    text={texts.downloads.voucherLabel}
                    label={texts.downloads.voucherLabel}
                    file={downloadFileVoucher}
                  />
                  <p className="d-flex" style={{ gap: '3px' }}>
                    <b>{texts.resume.paidAt}:</b>
                    <span>{paidAt}</span>
                  </p>
                </>
              )}
            </Col>
          </Card>
        </Col>
      </Card>

      <Card className="petition-comment-resolution mb-4">
        <Col xs={12} className="px-0 mb-4">
          <SectionTitle text={texts.resolution.resolutionTitle} />
          <TextAreaInput
            label=""
            name="description"
            onBlur={function noRefCheck() {}}
            onChange={function noRefCheck() {}}
            value={lastUpdate}
            height={95}
            disabled
          />
        </Col>

        <Col xs={12} className="px-0">
          <InputToolTip
            prefix={
              'studentManagement.tabs.petitionsHistory.detail.inputTooltips'
            }
            name={texts.resolution.resolutionDate}
            text={dayjs(lastUpdatedAt).format('DD/MM/YYYY')}
            status={currentStatus}
          />
        </Col>
      </Card>

      {downloadFileResponse && (
        <Card className="petition-attach-resolution mb-4">
          <Col xs={12} sm={12} md={8} className="px-0">
            <Card className="d-flex flex-column justify-content-start ">
              <Col xs={12} md={8} lg={6} className="px-0">
                <FileDownload
                  text={texts.downloads.downloadHistory}
                  label={texts.downloads.fileLabel}
                  file={downloadFileResponse}
                />
              </Col>
            </Card>
          </Col>
        </Card>
      )}
    </>
  );
}
